module.exports = __webpack_public_path__ + "img/lang-JP.eb4c08b4.svg";